module.exports = __webpack_public_path__ + "img/p7.8aea4d12.png";